import React from 'react';
import TransactionsPlaceManagement from "../place/TransactionsPlaceManagement";

const TransactionPlaceTab = () => {
    return (
        <>
            <TransactionsPlaceManagement/>
        </>
    );
};

export default TransactionPlaceTab;
